<template>
  <section class="eventos-wrapper">
    <!-- TARJETA ESTILO BOLETO / SAVE THE DATE -->
    <div class="boarding-card" ref="ticketRef">
      <!-- CABECERA TIPO PASE DE ABORDAR -->
      <div class="ticket-header" ref="headerRef">
        <span class="ticket-type">DESTINATION WEDDING</span>
        <span class="ticket-code">IT-2027</span>
      </div>

      <!-- ILUSTRACIÓN DE ITALIA (A MANO ALZADA) -->
      <div class="ilustracion-container" ref="sketchRef">
        <img 
          src="@/assets/italia-sketch.png" 
          alt="Italia - Boda Destino" 
          class="sketch-italia" 
        />
      </div>

      <!-- DETALLES DEL DESTINO -->
      <div class="destination-info">
        <p class="label-pasaje" ref="labelRef">PRÓXIMO DESTINO</p>
        <h2 class="pais-titulo" ref="tituloRef">Italia</h2>
      </div>

      <!-- MENSAJE EMOTIVO -->
      <p class="mensaje" ref="mensajeRef">
        El amor no conoce fronteras. Prepara las maletas y acompáñanos a decir 
        «Sí, acepto» bajo el cielo de Italia.
      </p>

      <!-- PIE DE TICKET DE ABORDAR -->
      <div class="ticket-footer" ref="footerRef">
        <div class="flight-detail mb-3">
          <span class="detail-title">UBICACIÓN</span>
          <span class="detail-value">Por Anunciar</span>
        </div>

        <!-- BOTÓN DE CONFIRMA TU ASISTENCIA CON SCROLL SUAVE -->
        <div class="rsvp-action-wrap">
          <button type="button" class="btn-rsvp-scroll" @click="scrollToRsvp">
Confirma tu asistencia          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { ref, onMounted } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'SaveTheDateItalia',
  setup() {
    const ticketRef = ref(null)
    const headerRef = ref(null)
    const sketchRef = ref(null)
    const labelRef = ref(null)
    const tituloRef = ref(null)
    const mensajeRef = ref(null)
    const footerRef = ref(null)

    // Función para hacer scroll suave al componente RSVP que está más abajo
    const scrollToRsvp = () => {
      // Busca el contenedor de tu otro componente (usando la clase de su contenedor)
      const rsvpElement = document.querySelector('.confirmation-container')
      
      if (rsvpElement) {
        rsvpElement.scrollIntoView({ 
          behavior: 'smooth', 
          block: 'center' 
        })
      }
    }

    onMounted(() => {
      // Estado inicial invisible para animación GSAP
      gsap.set([
        headerRef.value,
        sketchRef.value,
        labelRef.value,
        tituloRef.value,
        mensajeRef.value,
        footerRef.value
      ], { opacity: 0 })

      gsap.set(headerRef.value,  { y: -30 })
      gsap.set(sketchRef.value,  { scale: 0.8, y: -20 })
      gsap.set(labelRef.value,   { y: 20 })
      gsap.set(tituloRef.value,  { y: 30 })
      gsap.set(mensajeRef.value, { y: 20 })
      gsap.set(footerRef.value,  { y: 40 })

      // Timeline con ScrollTrigger
      gsap.timeline({
        scrollTrigger: {
          trigger: ticketRef.value,
          start: 'top 80%',
          toggleActions: 'play none none none',
          once: true
        },
        defaults: { ease: 'power2.out' }
      })
      .to(headerRef.value,  { y: 0, opacity: 1, duration: 0.5 })
      .to(sketchRef.value,  { scale: 1, y: 0, opacity: 1, duration: 0.7 }, '-=0.2')
      .to(labelRef.value,   { y: 0, opacity: 1, duration: 0.4 }, '-=0.3')
      .to(tituloRef.value,  { y: 0, opacity: 1, duration: 0.5 }, '-=0.2')
      .to(mensajeRef.value, { y: 0, opacity: 1, duration: 0.6 }, '-=0.3')
      .to(footerRef.value,  { y: 0, opacity: 1, duration: 0.5 }, '-=0.2')

      ScrollTrigger.refresh()
    })

    return {
      ticketRef,
      headerRef,
      sketchRef,
      labelRef,
      tituloRef,
      mensajeRef,
      footerRef,
      scrollToRsvp
    }
  }
}
</script>

<style scoped>
.eventos-wrapper {
  background-color: rgba(217, 212, 209, 0.95);
  padding: 60px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* CONTENEDOR ESTILO BOLETO / BOARDING PASS */
.boarding-card {
  width: 100%;
  max-width: 360px;
  background: #fbf9f6;
  border: 1px dashed #8a6a3f;
  border-radius: 16px;
  padding: 28px 22px;
  text-align: center;
  color: #8a6a3f;
  box-shadow: 0px 10px 25px rgba(138, 106, 63, 0.08);
  position: relative;
}

/* ENCABEZADO */
.ticket-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: 'Playfair Display', serif;
  font-size: 11px;
  letter-spacing: 2px;
  border-bottom: 1px solid rgba(138, 106, 63, 0.25);
  padding-bottom: 12px;
  margin-bottom: 24px;
}

.ticket-type {
  font-weight: 600;
}

.ticket-code {
  opacity: 0.7;
}

/* CONTENEDOR ILUSTRACIÓN */
.ilustracion-container {
  width: 100%;
  max-width: 220px;
  margin: 0 auto 20px auto;
}

.sketch-italia {
  width: 100%;
  height: auto;
  object-fit: contain;
  display: block;
}

/* TEXTOS Y TÍTULO */
.label-pasaje {
  font-family: 'Playfair Display', serif;
  font-size: 11px;
  letter-spacing: 3px;
  text-transform: uppercase;
  margin-bottom: 4px;
  opacity: 0.8;
}

.pais-titulo {
  font-family: 'Playfair Display', serif;
  font-size: 42px;
  letter-spacing: 4px;
  margin: 0 0 16px 0;
  font-weight: 400;
    color: #8a6a3f !important;

  text-transform: uppercase;
}

.mensaje {
  font-family: 'Playfair Display', serif;
  font-size: 14px;
  line-height: 1.7;
  margin-bottom: 28px;
  padding: 0 8px;
}

/* PIE DE BOLETO */
.ticket-footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  border-top: 1px dashed rgba(138, 106, 63, 0.35);
  padding-top: 16px;
  text-align: center;
}

.flight-detail {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.detail-title {
  font-family: 'Playfair Display', serif;
  font-size: 9px;
  letter-spacing: 1.5px;
  opacity: 0.7;
  margin-bottom: 3px;
}

.detail-value {
  font-family: 'Playfair Display', serif;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.5px;
}

/* BOTÓN DE SCROLL EDITORIAL */
.rsvp-action-wrap {
  width: 100%;
  margin-top: 10px;
}
@import url('https://fonts.googleapis.com/css2?family=Corinthia:wght@400;700&display=swap');
.btn-rsvp-scroll {
  width: 100%;
  padding: 10px;
  border: 1px solid #8a6a3f;
  background: transparent;
font-family: 'Corinthia', cursive;  font-size: 1.7rem !important;
    background: #252524;

  color: #ffff;
  cursor: pointer;
  transition: all 0.25s ease;
}

.btn-rsvp-scroll:hover {
  background: #8a6a3f;
  color: #ffffff;
}

.mb-3 {
  margin-bottom: 12px;
}
</style>